import { Text } from '~components/Typography';

import { IndicatorBar, IndicatorsTable, Section } from './styles';

type Props = {
	title: string;
	items: {
		id: string;
		percent: number;
		values: { value: string }[];
	}[];
};

export const ProfileCardIndicators = ({ title, items }: Props) => {
	return (
		<Section>
			{title && (
				<Text size="M" as="h5" align="left">
					{title}
				</Text>
			)}
			<IndicatorsTable>
				<tbody>
					{items.map((item) => {
						const from = item.values[0].value;
						const to = item.values[1].value;
						const value = item.percent;

						if (item.values.length === 2) {
							return (
								<tr key={item.id}>
									<th>
										<Text size="XS" as="span">
											{from}
										</Text>
									</th>
									<td>
										<IndicatorBar value={value} aria-label={`${value}%`} />
									</td>
									<th>
										<Text size="XS" as="span">
											{to}
										</Text>
									</th>
								</tr>
							);
						}
					})}
				</tbody>
			</IndicatorsTable>
		</Section>
	);
};
